export default __webpack_public_path__ + "static/media/support.c6f743be.svg";